import { axiosCms } from 'Axios.js';
import { authToken } from '../utility';
import * as actionTypes from './actionTypes';

const fetchPromosStart = () => ({ type: actionTypes.FETCH_PROMOS_START });

const fetchPromosEnd = data => ({ type: actionTypes.FETCH_PROMOS_END, data });

const fetchPromoStart = () => ({ type: actionTypes.FETCH_PROMO_START });

const fetchPromoEnd = data => ({ type: actionTypes.FETCH_PROMO_END, data });

const deleteThePromoduct = data => ({ type: actionTypes.DELETE_PROMODUCT, data });

const notifyPromoStart = () => ({ type: actionTypes.NOTIFY_PROMO_START });

const notifyPromoEnd = id => ({ type: actionTypes.NOTIFY_PROMO_END, id });

const getHighlightedPromos = data => ({ type: actionTypes.UPDATE_HIGHLIGHTED_PROMOS, data });

export const updateHighlightedPromos = (ids, onSuccess) => {
  return dispatch => {
    dispatch(fetchPromoStart());
    axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());
    return axiosCms
      .post('/promos-highlight', {
        items: ids.map((id, indx) => ({ id, order: indx })),
      })
      .then(response => {
        dispatch(getHighlightedPromos(response.data));
        if (onSuccess) {
          onSuccess();
        }
        return 'done';
      })
      .catch(err => {
        console.error('updateHighlightedPromos err: ', err);
        return Promise.reject(err);
      });
  };
};

export const fetchPromos = typePromo => {
  return dispatch => {
    dispatch(fetchPromosStart());

    axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());

    return axiosCms
      .get(`/promos${typePromo ? '?type=' + typePromo : ''}`)
      .then(response => {
        const { data } = response;
        dispatch(fetchPromosEnd(data));
        return 'done';
      })
      .catch(err => {
        console.error(`fetchPromos err: `, err);
        return Promise.reject(err);
      });
  };
};

export const deletePromoduct = (promo_id, product_id) => {
  return dispatch => {
    dispatch(deleteThePromoduct({ promo_id, product_id }));

    axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());

    return axiosCms
      .delete(`/promoducts/${promo_id}/${product_id}`)
      .then(res => res.message)
      .catch(err => {
        console.error('deletePromoduct err: ', err);
        return Promise.reject(err);
      });
  };
};

export const fetchPromo = id => {
  return dispatch => {
    dispatch(fetchPromoStart());

    axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());

    return axiosCms
      .get('/promos/' + id)
      .then(response => {
        dispatch(fetchPromoEnd(response.data));
        return 'fetched';
      })
      .catch(err => {
        console.error(`fetchPromo err: `, err);
        return Promise.reject(err);
      });
  };
};

export const createPromo = data => {
  return dispatch => {
    axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());

    return axiosCms
      .post('/promos', data)
      .then(response => {
        return dispatch(fetchPromos());
      })
      .catch(err => {
        console.error(`createPromo err: `, err);
        return Promise.reject(err);
      });
  };
};

export const patchPromo = data => {
  return dispatch => {
    const { id } = data;
    axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());

    return axiosCms
      .patch(`/promos/${id}`, data)
      .then(response => {
        dispatch(fetchPromo(id));
        return 'updated';
      })
      .catch(err => {
        console.error(`patchPromo err: `, err);
        return Promise.reject(err);
      });
  };
};

export const deletePromo = id => {
  return dispatch => {
    axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());

    return axiosCms
      .delete(`/promos/${id}`)
      .then(response => {
        dispatch(fetchPromos());
        return 'deleted';
      })
      .catch(err => {
        console.error(`deletePromo err: `, err);
        return Promise.reject(err);
      });
  };
};

export const notifyPromo = id => dispatch => {
  dispatch(notifyPromoStart());

  axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());
  return axiosCms
    .post(`/promos/${id}/notify`)
    .then(() => {
      dispatch(notifyPromoEnd(id));
      return 'notified';
    })
    .catch(err => {
      console.error(`notifyPromo err: `, err);
      return Promise.reject(err);
    });
};



// WEBPACK FOOTER //
// ./src/store/actions/promos.js